/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DistributionList } from '../models/distribution-list';
import { DistributionListEvent } from '../models/distribution-list-event';
import { DistributionListEventSummary } from '../models/distribution-list-event-summary';
import { EmailMessage } from '../models/email-message';
import { DirectEmailMessage } from '../models/direct-email-message';
import { CustomerDistribution } from '../models/customer-distribution';
@Injectable({
  providedIn: 'root',
})
class DistributionListService extends __BaseService {
  static readonly DistributionListCreateOrUpdatePath = '/api/DistributionList/CreateOrUpdate';
  static readonly DistributionListClonePath = '/api/DistributionList/Clone';
  static readonly DistributionListGetDistributionListPath = '/api/DistributionList/GetDistributionList';
  static readonly DistributionListGetRecentEventsPath = '/api/DistributionList/GetRecentEvents';
  static readonly DistributionListGetRecentEventsForUserPath = '/api/DistributionList/GetRecentEventsForUser';
  static readonly DistributionListSendPath = '/api/DistributionList/Send';
  static readonly DistributionListDataBusSendPath = '/api/DistributionList/DataBusSend';
  static readonly DistributionListDataBusSendDirectPath = '/api/DistributionList/DataBusSendDirect';
  static readonly DistributionListGetDistributionListsPath = '/api/DistributionList/GetDistributionLists';
  static readonly DistributionListDeletePath = '/api/DistributionList/Delete/{id}';
  static readonly DistributionListGetMyDistributionListsPath = '/api/DistributionList/GetMyDistributionLists';
  static readonly DistributionListGetAllDistributionListsPath = '/api/DistributionList/GetAllDistributionLists';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param distList undefined
   */
  DistributionListCreateOrUpdateResponse(distList: DistributionList): __Observable<__StrictHttpResponse<DistributionList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = distList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionList/CreateOrUpdate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DistributionList>;
      })
    );
  }
  /**
   * @param distList undefined
   */
  DistributionListCreateOrUpdate(distList: DistributionList): __Observable<DistributionList> {
    return this.DistributionListCreateOrUpdateResponse(distList).pipe(
      __map(_r => _r.body as DistributionList)
    );
  }

  /**
   * @param params The `DistributionListService.DistributionListCloneParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `distributionId`:
   */
  DistributionListCloneResponse(params: DistributionListService.DistributionListCloneParams): __Observable<__StrictHttpResponse<DistributionList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.newName != null) __params = __params.set('newName', params.newName.toString());
    if (params.distributionId != null) __params = __params.set('distributionId', params.distributionId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionList/Clone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DistributionList>;
      })
    );
  }
  /**
   * @param params The `DistributionListService.DistributionListCloneParams` containing the following parameters:
   *
   * - `newName`:
   *
   * - `distributionId`:
   */
  DistributionListClone(params: DistributionListService.DistributionListCloneParams): __Observable<DistributionList> {
    return this.DistributionListCloneResponse(params).pipe(
      __map(_r => _r.body as DistributionList)
    );
  }

  /**
   * @param distributionListId undefined
   */
  DistributionListGetDistributionListResponse(distributionListId?: number): __Observable<__StrictHttpResponse<DistributionList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (distributionListId != null) __params = __params.set('distributionListId', distributionListId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetDistributionList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DistributionList>;
      })
    );
  }
  /**
   * @param distributionListId undefined
   */
  DistributionListGetDistributionList(distributionListId?: number): __Observable<DistributionList> {
    return this.DistributionListGetDistributionListResponse(distributionListId).pipe(
      __map(_r => _r.body as DistributionList)
    );
  }

  /**
   * @param distributionListId undefined
   */
  DistributionListGetRecentEventsResponse(distributionListId?: number): __Observable<__StrictHttpResponse<Array<DistributionListEvent>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (distributionListId != null) __params = __params.set('distributionListId', distributionListId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetRecentEvents`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DistributionListEvent>>;
      })
    );
  }
  /**
   * @param distributionListId undefined
   */
  DistributionListGetRecentEvents(distributionListId?: number): __Observable<Array<DistributionListEvent>> {
    return this.DistributionListGetRecentEventsResponse(distributionListId).pipe(
      __map(_r => _r.body as Array<DistributionListEvent>)
    );
  }
  DistributionListGetRecentEventsForUserResponse(): __Observable<__StrictHttpResponse<Array<DistributionListEventSummary>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetRecentEventsForUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DistributionListEventSummary>>;
      })
    );
  }  DistributionListGetRecentEventsForUser(): __Observable<Array<DistributionListEventSummary>> {
    return this.DistributionListGetRecentEventsForUserResponse().pipe(
      __map(_r => _r.body as Array<DistributionListEventSummary>)
    );
  }

  /**
   * @param message undefined
   */
  DistributionListSendResponse(message: EmailMessage): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = message;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionList/Send`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param message undefined
   */
  DistributionListSend(message: EmailMessage): __Observable<Blob> {
    return this.DistributionListSendResponse(message).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `DistributionListService.DistributionListDataBusSendParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `apiKey`:
   */
  DistributionListDataBusSendResponse(params: DistributionListService.DistributionListDataBusSendParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.message;
    if (params.apiKey != null) __headers = __headers.set('apiKey', params.apiKey.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionList/DataBusSend`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `DistributionListService.DistributionListDataBusSendParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `apiKey`:
   */
  DistributionListDataBusSend(params: DistributionListService.DistributionListDataBusSendParams): __Observable<Blob> {
    return this.DistributionListDataBusSendResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `DistributionListService.DistributionListDataBusSendDirectParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `apiKey`:
   */
  DistributionListDataBusSendDirectResponse(params: DistributionListService.DistributionListDataBusSendDirectParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.message;
    if (params.apiKey != null) __headers = __headers.set('apiKey', params.apiKey.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionList/DataBusSendDirect`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `DistributionListService.DistributionListDataBusSendDirectParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `apiKey`:
   */
  DistributionListDataBusSendDirect(params: DistributionListService.DistributionListDataBusSendDirectParams): __Observable<Blob> {
    return this.DistributionListDataBusSendDirectResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customerId undefined
   */
  DistributionListGetDistributionListsResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<DistributionList>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetDistributionLists`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DistributionList>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DistributionListGetDistributionLists(customerId?: number): __Observable<Array<DistributionList>> {
    return this.DistributionListGetDistributionListsResponse(customerId).pipe(
      __map(_r => _r.body as Array<DistributionList>)
    );
  }

  /**
   * @param id undefined
   */
  DistributionListDeleteResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/DistributionList/Delete/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DistributionListDelete(id: number): __Observable<Blob> {
    return this.DistributionListDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customerId undefined
   */
  DistributionListGetMyDistributionListsResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<CustomerDistribution>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetMyDistributionLists`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CustomerDistribution>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DistributionListGetMyDistributionLists(customerId?: number): __Observable<Array<CustomerDistribution>> {
    return this.DistributionListGetMyDistributionListsResponse(customerId).pipe(
      __map(_r => _r.body as Array<CustomerDistribution>)
    );
  }

  /**
   * @param customerId undefined
   */
  DistributionListGetAllDistributionListsResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<CustomerDistribution>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionList/GetAllDistributionLists`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CustomerDistribution>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DistributionListGetAllDistributionLists(customerId?: number): __Observable<Array<CustomerDistribution>> {
    return this.DistributionListGetAllDistributionListsResponse(customerId).pipe(
      __map(_r => _r.body as Array<CustomerDistribution>)
    );
  }
}

module DistributionListService {

  /**
   * Parameters for DistributionListClone
   */
  export interface DistributionListCloneParams {
    newName?: null | string;
    distributionId?: number;
  }

  /**
   * Parameters for DistributionListDataBusSend
   */
  export interface DistributionListDataBusSendParams {
    message: EmailMessage;
    apiKey?: null | string;
  }

  /**
   * Parameters for DistributionListDataBusSendDirect
   */
  export interface DistributionListDataBusSendDirectParams {
    message: DirectEmailMessage;
    apiKey?: null | string;
  }
}

export { DistributionListService }
